import React, {Component} from 'react';
import Jumbo from '../../components/Jumbo/Jumbo';
import {Container, Row, Col} from 'reactstrap';
import Sponsors from '../../components/Sponsors/Sponsors';
import Images from './Images/Images';
import Iframe from 'react-iframe';
import Map from '../../components/Map/Map';

import cover from '../../assets/images/frontpage/IMG_1065.jpg';

class Homepage extends Component {
    render(){
        return (
            <div id='homepage' className='homepage-page'>
                <Jumbo title='Ungdomssamfundet' content='Ungdomsklubben for alle mellom 10 og 20 år i Halden. Klubben har sitt eget Ungdomsstyre så alle kan være med å bestemme hva vi gjør.' button="false" image={cover} />
                <Container>
                    <Row>
                        <Col xs='12' md='8'>
                            <section className='clubinfo-and-images'>
                                <Images/>
                            </section>
                        </Col>
                        <Col xs='12' md='4'>
                            <section className='calendar'>
                                <Iframe
                                    url="https://calendar.google.com/calendar/b/1/embed?showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;mode=AGENDA&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=extragiverglede.no_6hqdate3l74qpqm30uu7pet7d0%40group.calendar.google.com&amp;color=%23B1440E&amp;ctz=Europe%2FOslo"
                                    style={{borderWidth: 0}} width="300" height="600" frameBorder="0"
                                    scrolling="no">iFrame</Iframe>
                            </section>
                        </Col>
                    </Row>
                </Container>
                <section className='sponsors'>
                    <Container>
                        <h2>Støttespillere</h2>
                        <Sponsors />
                    </Container>
                </section>
                <section>
                    <Map  isMarkerShown
                          googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyCD4bEKxnOeNZM5tuF3AmWIQtnGWxxhvus"
                          loadingElement={<div style={{ height: `100%` }} />}
                          containerElement={<div style={{ height: `400px` }} />}
                          mapElement={<div style={{ height: `100%` }} />}
                    />
                </section>
            </div>
        )
    };
};

export default Homepage;


// WEBPACK FOOTER //
// ./src/containers/Homepage/Homepage.js